export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14035.0ebbc6a1.jpg";